import {createApi} from '@reduxjs/toolkit/dist/query/react'
import {baseQueryWithReauth} from './BaseQueryReauth'
import {DataCSR, DataEr, DataHr, DataLr, IRequestCSR, IRequestHr, IRequestLr} from '../modules/csr/core/_models'

export const csrAPI = createApi({
  reducerPath: 'csrAPI',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['csr'],
  endpoints: (build) => ({
    dataFetch: build.mutation<DataCSR, IRequestCSR>({
      query: ({id, filter, account_id}) => ({
        method: 'POST',
        url: `/extensions/csr/${id}`,
        body: filter,
        params: account_id ? {account_id} : {},
      }),
    }),
    linesFetchReport: build.mutation<DataLr, IRequestLr>({
      query: ({id, filter, account_id}) => ({
        method: 'POST',
        url: `/extensions/csr/${id}/lines`,
        body: filter,
        params: account_id ? {account_id} : {},
      }),
    }),
    employeesFetchReport: build.mutation<DataEr, IRequestLr>({
      query: ({id, filter, account_id}) => ({
        method: 'POST',
        url: `/extensions/csr/${id}/employees`,
        body: filter,
        params: account_id ? {account_id} : {},
      }),
    }),
    hourlyFetchReport: build.mutation<DataHr, IRequestHr>({
      query: ({id, filters, account_id}) => ({
        method: 'POST',
        url: `/extensions/csr/${id}/hourly`,
        body: filters,
        params: account_id ? {account_id} : {},
      }),
    }),
  }),
})
